import React from 'react'
import MaterialSymbol from '../material-symbol'

const Add = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="add" {...props} />
))

Add.displayName = 'Add'

export default Add
